import {
  SegmentCondition,
  SegmentConditionGroup,
  ConditionOperator,
  SegmentConditionOperatorBetween,
  SegmentConditionOperatorMulti,
  SegmentConditionOperatorSingle,
  SegmentConditionOperatorValueLess,
  SegmentConditionSimple,
  BetweenCondition,
  MultiCondition,
  SingleCondition,
  ExistenceCondition,
} from './types';

export function isConditionsGroup(
  condition: SegmentCondition,
): condition is SegmentConditionGroup {
  return 'operator' in condition;
}

export function isConditionSimple(
  condition: SegmentCondition,
): condition is SegmentConditionSimple {
  return !isConditionsGroup(condition);
}

export function isSingleOperator(
  operator: ConditionOperator,
): operator is SegmentConditionOperatorSingle {
  return (
    operator === 'eq' ||
    operator === 'noteq' ||
    operator === 'gte' ||
    operator === 'lte'
  );
}

export function isMultiOperator(
  operator: ConditionOperator,
): operator is SegmentConditionOperatorMulti {
  return operator === 'in' || operator === 'notin';
}

export function isValueLessOperator(
  operator: ConditionOperator,
): operator is SegmentConditionOperatorValueLess {
  return operator === 'notset' || operator === 'any';
}

export function isBetweenOperator(
  operator: ConditionOperator,
): operator is SegmentConditionOperatorBetween {
  return operator === 'between';
}

export function isSingleCondition(condition: any): condition is SingleCondition {
  return isSingleOperator(condition.operator);
}

export function isMultiCondition(condition: any): condition is MultiCondition {
  return isMultiOperator(condition.operator);
}

export function isBetweenCondition(condition: any): condition is BetweenCondition {
  return isBetweenOperator(condition.operator);
}

export function isValueLessCondition(condition: any): condition is ExistenceCondition {
  return isValueLessOperator(condition.operator);
}

function padZero(num: number): string {
  return String(num).padStart(2, '0');
}

export function formatDateToUTCString(date: Date): string {
  const year = date.getUTCFullYear();
  const month = padZero(date.getUTCMonth() + 1);
  const day = padZero(date.getUTCDate());
  const hours = padZero(date.getUTCHours());
  const minutes = padZero(date.getUTCMinutes());
  const seconds = padZero(date.getUTCSeconds());

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export function parseUTCStringToDate(dateString: string): Date {
  const [
    year,
    month,
    day,
    hours,
    minutes,
    seconds,
  ] = dateString.split(/[\s-T:]/).map(Number);
  return new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds));
}

/*
async function test<T>(pr: Promise<T>): Promise<{ id: number; } & T> {
  const res = await pr;
  return {
    id: 1,
    ...res,
  };
}
*/
